
jQuery('document').ready(function($){
  // Sidecart
  $('.close-cart, .header-cart-icon, .sidecartoverlay').on('click', function(e){
    e.preventDefault();
    $(".sidecart").toggle('fast');
    $(".sidecartoverlay").toggle();
  });

  $('body').on('added_to_cart',function(e){
    e.preventDefault();
    $(".sidecart").toggle('fast');
    $(".sidecartoverlay").toggle();
  });

  $('body').on('click', '.wc-checkout-method-icon', function(){
    $([document.documentElement, document.body]).animate({
      scrollTop: ($("#order_review").offset().top - 100)
  }, 1000);
  });
});
